/* ============================================================
   OBEE EXTRACTS — Asset-Pfade

   Shopify erlaubt keine Unterordner in assets/. Alle Dateien
   heissen deshalb flach: fruit-cherry-1.webp, spin2-on-01.webp.

   Im Theme setzt layout/theme.liquid die Variable OBEE_ASSET_BASE
   auf die CDN-Adresse. In der lokalen Vorschau bleibt sie leer,
   dann greift der Standardwert "assets/".
   ============================================================ */
window.OBEE_ASSET = function (name) {
  return (window.OBEE_ASSET_BASE || 'assets/') + name + (window.OBEE_ASSET_V || '');
};
